/* eslint-disable react/jsx-pascal-case */
import {
  CmpSelectBox,
  CmpButton,
  CmpDatePicker,
} from "../../Component/Common/ToolBox/ToolBox";
import React, { useState, useEffect, useRef, useCallback } from "react";
import { useDispatch } from "react-redux";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { fExecuteAPI } from "../../Server/Apis";
import { useSelector } from "react-redux";
import {
  Set_SliceWmsPoPhysicalStockCount_SummaryObj,
  Set_SliceWmsPoPhysicalStockCount_HeadObj,
} from "./SliceWmsPoPhysicalStockCount";
import { Summary_Grid_Columns } from "./WmsPoPhysicalStockCountAction";
import moment from "moment";
import { fAlertToast, GetGitterColumns } from "../../Utility/Utilitys";
import WmsPoPhysicalStockCount_BreadCrumbs from "./WmsPoPhysicalStockCount_BreadCrumbs";
import useMediaQuery from "@mui/material/useMediaQuery";
import GCSummaryModal from "../../Component/Common/ReuseableComponent/GCSummaryModal";
import DetailCardComp, { DetailInputDisplay } from "../../Component/Common/ReuseableComponent/DetailCardComp";
export default function WmsPoPhysicalStockCount() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const LocationFocusOnLoad = useRef(null);
  const vRdxuserLoc = useSelector((state) => state.SliceGRNLocation.value);
  const vRdxuserInfo = useSelector((state) => state.login.value);
  const [sSummaryGridRow, setSummaryGridRow] = useState([]);
  // modal start

  const [showModal, setShowModal] = useState(false);

  // modal end

  const [sSummaryObj, setSummaryObj] = useState({
    loc: vRdxuserLoc[0]?.UID,
    dateFrom: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate() - 10
    ),
    dateTo: new Date(),
  });
  const fSummary_OnChange = (e) => {
    setSummaryObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fLoad = (e) => {
    dispatch(
      Set_SliceWmsPoPhysicalStockCount_SummaryObj({
        sSummaryObj,
      })
    );
    Get_Load_Grid_Data();
    setShowModal(false);
  };
  const Get_Load_Grid_Data = useCallback(async () => {
    var vSummaryObj = {
      Loc: sSummaryObj.loc === "" ? vRdxuserLoc[0]?.UID : sSummaryObj?.loc,
      Date1: moment(sSummaryObj?.dateFrom).format("MM/DD/YYYY"),
      Date2: moment(sSummaryObj?.dateTo).format("MM/DD/YYYY"),
      UserCd: vRdxuserInfo.UserID,
    };
    const vItemSearch = await fExecuteAPI(
      "WMPOIPT01_poSummary_GETROW",
      vSummaryObj
    );
    if (vItemSearch?.Type?.toUpperCase() === "SUCCESS") {
      if (vItemSearch?.ResultSet?.length > 0) {
        const itemRows = vItemSearch?.ResultSet?.map((obj, i) => ({
          ...obj,
          id: i + 1,
        }));
        setSummaryGridRow(itemRows);
      } else {
        setSummaryGridRow([]);
      }
    } else {
      fAlertToast("FAILED", vItemSearch?.Message);
    }
  }, [
    sSummaryObj.loc,
    sSummaryObj.dateFrom,
    sSummaryObj.dateTo,
    vRdxuserLoc,
    vRdxuserInfo.UserID,
  ]);

  const fRowCLick = (item) => {
    dispatch(
      Set_SliceWmsPoPhysicalStockCount_HeadObj({
        SheetNo: item.row.A_SheetId,
        Loc: item.row.A_Loc,
        LocName: item.row.LocName,
        Date: item.row.A_Date,
        ReferenceNo: item.row.A_RefNo,
        A_DocStat: item.row.A_Status,
        PoType: item.row.A_POTyp,
        POTypeName: item.row.POTypeName,
        PoNo: item.row.A_PONo,
        PDTUserCode: item.row.A_UserCd,
        PDTUserName: item.row.Username,
      })
    );
    navigate("/WmsPoPhysicalStockDetail");
  };

  // const fNew = () => {
  //   dispatch(
  //     Set_SliceWmsPoPhysicalStockCount_HeadObj({
  //       SheetNo: 0,
  //       Loc: vRdxuserLoc[0]?.UID,
  //       LocName: "",
  //       Date: new Date(),
  //       ReferenceNo: "",
  //       A_DocStat: "ENTER",
  //       PoType: "",
  //       PoNo: "",
  //       PDTUserCode: "",
  //       PDTUserName: "",
  //     })
  //   );
  //   navigate("/WmsPoPhysicalStockDetail");
  // };
  const [sSummaryGridColumn2, setSummaryGridColumn2] = useState([]);

  useEffect(() => {
    GetGitterColumns(
      setSummaryGridColumn2,
      "WMPOIPT01_SUMMARY",
      Summary_Grid_Columns
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    Get_Load_Grid_Data();
  }, []);

  useEffect(() => {
    LocationFocusOnLoad?.current?.focus();
  }, []);
  return (
    <div className="container-fluid my-3">
      <div className="Breadcrumbs d-flex justify-content-between align-items-center">
        <WmsPoPhysicalStockCount_BreadCrumbs />
        <CmpButton
          xbtnName="Filter"
          xOnClick={() => {
            setShowModal(true);
          }}
          xVariant="contained"
          xSize="small"
        />
      </div>
      <div style={{ margin: "auto", width: "100%" }}>
        <Grid
          container
          spacing={{ xs: 2, sm: 2, md: 2 }}
          className="align-items-center"
          style={{ display: "none" }}
        >
          <Grid item lg={2} md={4} xs={6}>
            <CmpSelectBox
              xref={LocationFocusOnLoad}
              xLabelText="Location"
              xValue={sSummaryObj.loc}
              xOnChange={(event) => fSummary_OnChange(event)}
              xName={"loc"}
              xData={vRdxuserLoc}
              xValueMember={""}
              xDispalyMember={""}
              xError={false}
              xErrorMessage={false}
              xDisable={false}
            />
          </Grid>
          <Grid item lg={2} md={4} xs={6} className="bintransfer-data-date">
            <CmpDatePicker
              xLabelText={"From"}
              xValue={sSummaryObj.dateFrom}
              xOnChange={(newValue) => {
                setSummaryObj((obj) => ({
                  ...obj,
                  dateFrom: newValue.$d,
                }));
              }}
              xName={"dateFrom"}
              xError={false}
              xErrorMessage={false}
            />
          </Grid>
          <Grid item lg={2} md={4} xs={12} className="bintransfer-data-date">
            <CmpDatePicker
              xLabelText={"To"}
              xValue={sSummaryObj.dateTo}
              xOnChange={(newValue) =>
                setSummaryObj((obj) => ({ ...obj, dateTo: newValue.$d }))
              }
              xName={"dateTo"}
              xError={false}
              xErrorMessage={false}
            />
          </Grid>

          <Grid item lg={2} md={4} xs={6} className="bintransfet-data-load-btn">
            <CmpButton
              xbtnName="Load"
              xOnClick={fLoad}
              xVariant="contained"
              xSize="small"
            />
          </Grid>

          {/* <Grid item lg={2} md={4} xs={6} className="bintransfet-data-load-btn">
            <CmpButton
              xbtnName="New"
              xOnClick={fNew}
              xVariant="contained"
              xSize="small"
            />
          </Grid> */}
        </Grid>
        <>
          <Box
            sx={{ height: vMediaQuery ? "50vh" : "70vh", width: "100%" }}
            className="bin-transfer-data"
          >
            {/* <DataGrid
              rowHeight={30}
              headerHeight={40}
              getRowClassName={(params) =>
                params.indexRelativeToCurrentPage % 2 === 0
                  ? "mui-even-row"
                  : "mui-odd-row"
              }
              sx={{
                border: 1,
                borderColor: "primary.light",
              }}
              rows={sSummaryGridRow}
              columns={sSummaryGridColumn2}
              hideFooter={sSummaryGridRow.length < 100}
              onRowClick={fRowCLick}
              components={{
                Toolbar: vMediaQuery ? "" : GridToolbar,
              }}
            /> */}


            <div
          style={{
            height: vMediaQuery ? "65vh" : "80vh",
            overflowY: "auto",
            marginTop: "14px",
          }}
        >
          <Grid container spacing={1}>
            {Array.isArray(sSummaryGridRow) &&
              sSummaryGridRow?.length > 0 &&
              sSummaryGridRow?.map((item, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <DetailCardComp
                    data={item}
                    onClick={(item) => {
                      fRowCLick({ row: item });
                    }}
                    headerLabel={item.LocName}
                    content={
                      <Grid container spacing={1}>
                        <DetailInputDisplay
                          label="Sheet No"
                          value={item.A_SheetId}
                        />
                        <DetailInputDisplay
                          label="Ref.No"
                          value={item.A_RefNo}
                        />
                        <DetailInputDisplay
                          label="Date"
                          value={moment(item.A_Date).format("DD/MM/YYYY")}
                        />
                        <DetailInputDisplay
                          label="Status"
                          value={` ${item.A_Status}`}
                        />
                      </Grid>
                    }
                  />
                </Grid>
              ))}
          </Grid>
        </div>

          </Box>
        </>
      </div>
      <GCSummaryModal
        xOpen={showModal}
        fCloseModal={() => {
          setShowModal(false);
        }}
        xTitle="Filter"
        component={
          <>
            <Grid container spacing={2} className="align-items-center">
              <Grid item xs={6}>
                <CmpSelectBox
                  xref={LocationFocusOnLoad}
                  xLabelText="Location"
                  xValue={sSummaryObj.loc}
                  xOnChange={(event) => fSummary_OnChange(event)}
                  xName={"loc"}
                  xData={vRdxuserLoc}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={false}
                  xErrorMessage={false}
                  xDisable={false}
                />
              </Grid>
              <Grid item xs={6} className="bintransfer-data-date">
                <CmpDatePicker
                  xLabelText={"From"}
                  xValue={sSummaryObj.dateFrom}
                  xOnChange={(newValue) => {
                    setSummaryObj((obj) => ({
                      ...obj,
                      dateFrom: newValue.$d,
                    }));
                  }}
                  xName={"dateFrom"}
                  xError={false}
                  xErrorMessage={false}
                />
              </Grid>
              <Grid item xs={6} className="bintransfer-data-date">
                <CmpDatePicker
                  xLabelText={"To"}
                  xValue={sSummaryObj.dateTo}
                  xOnChange={(newValue) =>
                    setSummaryObj((obj) => ({ ...obj, dateTo: newValue.$d }))
                  }
                  xName={"dateTo"}
                  xError={false}
                  xErrorMessage={false}
                />
              </Grid>

              <Grid
                item
                xs={12}
                className="bintransfet-data-load-btn text-center"
              >
                <CmpButton
                  xbtnName="Load"
                  xOnClick={fLoad}
                  xVariant="contained"
                  xSize="small"
                />
              </Grid>

              {/* <Grid item lg={2} md={4} xs={6} className="bintransfet-data-load-btn">
            <CmpButton
              xbtnName="New"
              xOnClick={fNew}
              xVariant="contained"
              xSize="small"
            />
          </Grid> */}
            </Grid>
          </>
        }
      />
    </div>
  );
}
